import {
    CallToAction,
    Content,
    Email,
    Header,
    Paragraph,
    Title,
} from "@rakered/email";

export default function ConsentFormAndPasswordEmail(props) {
    return (
        <Email>
            <Content>
                <Header logo="https://www.sportsviz.com/email/logo512_large.png" />
                <Title>Complete Registration</Title>

                <Paragraph>
                    You have been registered on the Nodiant Online Platform.
                </Paragraph>
                <Paragraph>
                    To finalise the process, we need your consent.
                </Paragraph>

                <CallToAction
                    href={`https://nodiant.faw.cymru/${props.path}?key=${props.userKey}&email=${props.email}`}
                >
                    Complete Registration
                </CallToAction>
            </Content>
        </Email>
    );
}
